import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Eric&apos;Cheng</h2>
        <p><a href="mailto:matsumi_design@163.com">matsumi_design@163.com  +8613072158895</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m chengjian. I like building things. I am a  <a href="https://www.ecnu.edu.cn/">East China Normal University</a> graduate, software engineering Alumni,
        and the Blockchain Architect of <a href="https://alading.com">Alading</a>. Previously,
        I was worked at blockchain laboratory of <a href="https://www.dodoca.com">dodoca </a>and <a href="https://www.ibm.com/cn-zh">IBM</a>
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; CHENG  &apos;JIAN <Link to="/">www.codingwithchengjian.com</Link>.</p>
    </section>
  </section>
);

export default SideBar;
